import { render, staticRenderFns } from "./ProjectDetailsForm.vue?vue&type=template&id=2e38eb38&"
import script from "./ProjectDetailsForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProjectDetailsForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProjectDetailsForm.vue?vue&type=style&index=0&id=2e38eb38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports